import { SEND_REVIEW_REQUEST, sendReviewFailed, sendReviewSucceeded } from '@va/dashboard/actions/api';
import Api from '@va/dashboard/api-client/index';
import { getInstanceId } from '@va/dashboard/selectors/app';
import { all, call, put, select, takeLatest } from 'redux-saga/effects';

export function* watchers() {
  yield all([takeLatest(SEND_REVIEW_REQUEST, sendReview)]);
}

export function* sendReview(action) {
  try {
    const websiteId = yield select(getInstanceId);
    const data = yield call(Api.sendReview, websiteId, {
      dontShowReview: action.dontShowReview,
      reviewStars: action.reviewStars,
      reviewFeedback: action.reviewFeedback,
    });
    yield put(sendReviewSucceeded(data));
  } catch (error) {
    yield put(sendReviewFailed(error));
  }
}
